import React from 'react';
import Header from '../components/Header';
import CaseStudiesHero4 from '../components/CaseStudyFour/CaseStudiesHero4';
import CaseStudiesBeginning4 from '../components/CaseStudyFour/CaseStudiesBeginning4';
import CaseStudiesTesting4 from '../components/CaseStudyFour/CaseStudiesTesting4';
import CaseStudiesResults4 from '../components/CaseStudyFour/CaseStudiesResults4';
import CaseStudiesCallout4 from '../components/CaseStudyFour/CaseStudiesCallout4';
import '../styles/custom.css';

const CaseStudiesPageFour = () => {
  return (
    
    <div className="page-wrapper">
      <Header />
      <CaseStudiesHero4 />
      <CaseStudiesBeginning4 />
      <CaseStudiesTesting4 />
      <CaseStudiesResults4 />
      <CaseStudiesCallout4 />
    </div>
  );
}

export default CaseStudiesPageFour;